"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rollForwardGenerator = void 0;
/**
 * Above a zero floor a proposal is BORN COMPLETE: one line per product of the
 * target week's carta, in carta order, at
 * `max(minQuantityPerProduct, last week's quantity)` — the previous order seeds
 * the quantities, the carta decides the lines. A product withdrawn from the
 * carta is dropped (substitution is a future concern); a product the store
 * never ordered starts at the floor. No history → the whole carta at the floor,
 * a real order the store will receive unless it edits, which is the agreed
 * model: below the floor, "not ordering a product" does not exist.
 *
 * With a floor of 0 that model does not apply and nothing is invented: only the
 * previous order's own quantities survive, and a product it never named stays
 * OFF the proposal rather than landing on it as a zero. No history and a floor
 * of 0 therefore produce an empty proposal — the untouched "sin pedido" state,
 * and the same absence the client boundary and the CSV keep.
 *
 * PURE domain: data → data, no DB/IO. Shared by services/backend and
 * services/backoffice (was field-for-field duplicated in both).
 */
exports.rollForwardGenerator = {
    generatedBy: 'ROLL_FORWARD',
    generate: ({ lastOrderProducts, menuProductIds, minQuantityPerProduct }) => {
        const previousByProduct = new Map((lastOrderProducts ?? []).map((line) => [line.productId, line.quantity]));
        return menuProductIds
            .map((productId) => ({
            productId,
            quantity: Math.max(minQuantityPerProduct, previousByProduct.get(productId) ?? 0),
        }))
            // Above a zero floor this drops nothing, so the proposal is born
            // complete. It only bites with a floor of 0, where emitting a line at 0
            // for a product the previous order never named would store an absence as
            // a zero — and the client boundary, which drops zeros on save, would turn
            // it back into an absence on the store's first save, filling the trail
            // with `0→none` for products nobody touched. ABSENT ≠ ZERO has to be the
            // same rule in every writer.
            .filter((line) => line.quantity > 0);
    },
};
//# sourceMappingURL=roll-forward.js.map